// src/pages/Notifications.jsx
import React from "react";

const Notifications = () => {
  // Sample notifications
  const notifications = [
    "गावठाण मध्ये नवीन पंप सेट सुरु",
    "अंगणवाडी मधील कार्यक्रम सोमवारला",
    "शाळेतील प्रवेशासाठी अर्ज सुरू",
    "निवडणूक आयोगाची माहिती अपडेट",
    "पाणीटंचाई निवारणासाठी नवीन योजना जाहीर",
    "महिला बचत गटांसाठी विशेष अनुदान योजना",
  ];

  return (
    <div className="max-w-4xl mx-auto px-6 py-10">
      <h1 className="text-3xl font-bold mb-6 text-center">सूचना / Notifications</h1>

      <div className="grid gap-4 md:grid-cols-2">
        {notifications.map((note, index) => (
          <div
            key={index}
            className="bg-white p-4 rounded-lg shadow-md border-l-4 border-blue-500 hover:bg-blue-50 transition cursor-pointer"
          >
            <p className="text-gray-800 font-medium">{note}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Notifications;
